interface PartnerWarningBannerProps {
  message: string;
}

export function PartnerWarningBanner({ message }: PartnerWarningBannerProps) {
  return (
    <div className="mb-4 bg-yellow-50 border border-amber-300 rounded-xl p-4 flex items-start gap-3" role="alert">
      <svg className="w-5 h-5 text-amber-500 shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4.5c-.77-.833-2.694-.833-3.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z" />
      </svg>
      <p className="text-sm text-amber-800 whitespace-pre-line">{message}</p>
    </div>
  );
}
